require('./flashNote.less');

var NoteView = require('../note'),
    _ = require('underscore'),
    $ = require('jquery'),
    Flashback;

require('jquery.ui.effect.explode');



module.exports = NoteView.extend({

    defaultCountdown: 10,

    ui: _.extend( NoteView.prototype.ui, {
        emailWr:        '.fn-email-wr',
        fnEmail:        '.fn-email',
        flashIcon:      '.icon-flash',
        toggleDiv:      '.r2',
        userName:       '.userName',
        modBtns:        '.modBtns',
        submitRow:      '.submit-row',
        headRight:      '.headRight',
        headLeft:       '.headLeft' //don't append to username.... max width
    }),

    onRender: function () {

        NoteView.prototype.onRender.call(this);
         _.bindAll(this, 'openUnread', 'openingNote', 'closeNote', 'destroy');

        this[ this.model.isNew() ? 'onRenderNewUnsaved' : 'onRenderNotNewOrNewCreatedByUser' ]();

        return this;

    },


    onRenderNewUnsaved: function() {

        // Not using _recipientIsCurrentUser b/c view not ready until 'show' now
        this.model.get('accessGroup') !== this.options.channel.request('notes:getUserPrivateID') &&
            this.ui.emailWr.removeClass('hide');
    },
    /*
    * A newly created note by the user or a note that isn't new.
    * check if accesibleBy is null, if so, use the prev
    * TODO: template -- extend template part or extend ui post prepend -- could have 2 templates
    * */
    onRenderNotNewOrNewCreatedByUser: function() {  /*  */

        this.$timer = $('<span class="timer hide"></span>')
            .prependTo( this.ui.iconWrapper ); //(don't append at time (start it hidden), then dupe made when toggleReply mode)

        this.$el.unselectable().on( 'click', this.openUnread ); //(don't delegate events on view -- not working for new
        this._fadeFlashInAndOut();

    },

    _fadeFlashInAndOut: function() {
        var $flash = this.ui.flashIcon,
         fadeInAndOut = function() {
            $flash.stop(true).fadeOut(600).fadeIn( {
                duration: 600,
                complete: fadeInAndOut
            });
        };
        fadeInAndOut();
    },

    // Access group is really mail recipient for this note type
    // Toggle email option if not 'me'
    onAccessGroupChange: function( accessGroup ) {

        this.ui.emailWr[ (this._recipientIsCurrentUser() ? 'add' : 'remove') + 'Class' ]('hide');

    },

    openUnread: function() {

        var lCh = this.options.channel,
            vCh = lCh.request('vChannel');

        // TODO: for edit/expand toggle call from WF -- set css and toggle event handlers there -- more intuitive
        //( if a note is clicked while in edit mode, don't allow open)
        if ( lCh.request('inEditMode' ))
            return false;

        this.$el
            .addClass('self-destruct')
            .off('click'); //set b/f open

        this.unbindKeyboardEvents();
        this.model.FN_WAS_OPENED = true; // SET FLAG ON MODEL TO PREV ESC FROM ESCAPING IT

        this.model.getFlashNoteContentAndDestroyOnServer()

            .done( _.bind( function(noteContent) {

                // Setting to the active note disallows interaction w/other flash notes (dupes into edit mode)
                // -- it's not really active in the sense others are in the application; but piggy-back off certain functionality it gives us
                lCh.trigger( 'notes:changeActiveNote', this.model, {isReadingFlashNote: true} );
                this.$el.removeClass('edit-mode'); // applied from reg note toggle ....
                this.ui.bodyField.text(noteContent); // should have below in reaction to event above

                if ( this.options.channel.request('vChannel').request('allowCreateDocNote') ) {

                    this.listenToOnce( this.uiModel, 'change:replyMode', this._toggleReplyMode );
                    this._createReplyBtn();
                }

                this.selfDestruct( this.defaultCountdown );

            }, this))

            .fail( function(data)  {

                vCh.command('ajaxError', data, 'Unable to Retrieve Flash Note Message.  Please try again later.');

            });

    },
    _createReplyBtn: function() {
        //use mousedown -- will fire b/f click
        this.btnReply = $('<i class="btnFlashBack icon-reply-1" title="Flashback"></i>')
            .appendTo(this.ui.headLeft)
            .on('mousedown', _.bind(this._replyBtnHandle, this));
    },
    _replyBtnHandle: function(e) {
        e.stopPropagation();
        this.uiModel.toggle('replyMode');
    },
    _toggleReplyMode: function(ui, enter) {

        if (enter) {
            this.undelegateEvents(); //-- DONT DO -- THEN THIS.UI.TOGGLEDIV WILL CAUSE ERR WHEN ENTER STOP SELF DESTRUCT

            this.listenToOnce(this.uiModel, 'change:replyMode', this._toggleReplyMode); //need to put in again .... (i think marionette's undelegate ...)
            this.btnReply.addClass('active').off('mousedown');
            this._stopSelfDestruct();
            this.$el.addClass('replyMode');

            var newModel = this.options.channel.request('newNoteModel', true, 'FLASH_NOTE');

            newModel.parentFlashBackNote = this.model; //for identification

            Flashback = Flashback || require('./flashBackReply'); //necessary for recursion
            this.flashBackView = new Flashback({
                model: newModel,
                parentView: this, //to access the toggle
                channel: this.options.channel
            });
            this.flashBackView.render().$el.insertAfter( this.$('.r2') ); /* have the text above */

        } else {

            /* this should come from save / cancel of new note */
            this.delegateEvents();
            this.listenToOnce(this.uiModel, 'change:replyMode', this._toggleReplyMode); //need to put in again .... (i think marionette's undelegate ...)
            this.flashBackView.destroy();
            this.btnReply.removeClass('active');
            this.selfDestruct( parseInt(this.$('.timer').text()) ); //for now get back time from the DOM
            this.$el.removeClass('replyMode');
            this.btnReply.on('mousedown', _.bind(this._replyBtnHandle, this));
        }
    },

    // TODO: disallow if click reply button
    openingNote: function() {
        var self = this;
        return $.Deferred(function($dfd) {
            $.when( self.ui.toggleDiv.stop().slideDown() ).done($dfd.resolve);
        }).promise();
    },
    closeNote: function (e) {
        this.delegateCollapsibleHandlers();
        this.ui.toggleDiv.stop().slideUp();
    },
    delegateCollapsibleHandlers: function() {
        this.$el.off('mousedown mouseup').on('mousedown', this.openingNote).on('mouseup', this.closeNote);
    },
    /* start / resume self destruct */
    selfDestruct: function(timeLeft) {

        this.openingNote().done( _.bind(function() {

            this.destructTimer = null; /* gl: now start, stop */
            this.delegateCollapsibleHandlers();

            var self = this,
                fnSetTime = function() {
                    self.$timer.fadeOut(200, function() {
                        $(this).text(timeLeft).fadeIn(200);
                    });
                };


            //DOM slop for now: replace the icon w/ timer -- have space remain the same size
            this.ui.iconWrapper.width( this.ui.iconWrapper.width()  );
            this.ui.flashIcon.stop(true).fadeIn(0).stop(true).remove();
            this.$timer.removeClass('hide');

            fnSetTime.call(this);

            /*gl to pause */
            this.destructTimer = setInterval( _.bind( function() {

                fnSetTime.call(this);
                timeLeft--;

                if (timeLeft === 0) {
                    // ( if no perm, btnReply doesn't exist )
                    this.btnReply && this.btnReply.off().fadeOut(200, function() {
                        $(this).remove();
                    });
                    this._stopSelfDestruct();
                    this._blowUpAndDestroy();
                }

            }, this), 1000);

        }, this));


    },
    _stopSelfDestruct: function() {

        this.$el.stop(true).off('mousedown mouseup');
        this.$el.removeClass('replyMode');
        clearInterval(this.destructTimer);

    },
    _getRawUserInput: function() {


        return _.extend( NoteView.prototype._getRawUserInput.call(this), {
            sendEmail: !this._recipientIsCurrentUser() && this.ui.fnEmail.is(':checked') //send email to recipient if checked and is not the current user
        });

     },

    // Prior to save (note: user the selected value -- not bound to the model)
    // TODO: it should be bound to the model ... refactor
    _recipientIsCurrentUser: function() {
        return this.accessGroupSelectorView.getSelectedGroup().groupId ===
            this.options.channel.request('notes:getUserPrivateID');
    },

    onSaveIndicatorComplete: function() {

        var sentToSelf =
            this.model.get('accessGroup') === this.options.channel.request('notes:getUserPrivateID');

        !sentToSelf && this._blowUpAndDestroy(1);
    },
    /*
    * Also called on creation after save of new ones sent to other users
    * (the user will not see, so delete the view).
    * ( In additional to blowing up after reading ).
    * */
    _blowUpAndDestroy: function( postSaveOfNewNoteSentToOtherUser ) {

        var params = {
            effect: 'explode',
            pieces: 50,
            duration: 1000,
            complete: _.bind (this._destroyFlashNote, this, postSaveOfNewNoteSentToOtherUser )
        },
        self = this;

        setTimeout( function() {
            self.$el.effect( params );
        }, 1000);

    },

    /*
    * Really: 'Destroy after blowup'
    * Sources:
    * - post save of newly created note not sent to self (want view removed)
    * - post user opening note and countdown expiration ( it's already destroyed on the server )
    * ( Now only called from fn'_blowUpAndDestroy')
    * TODO: (old) if note created to self -- zombie's created -- remove the model/view -- STILL AN ISSUE ?
    * */
    _destroyFlashNote: function( postSaveOfNewNoteSentToOtherUser ) {


        this.$el.stop(true);

        /*
        * Enter the 'delete note' workflow to remove from collections, update note counts, etc.
        * The model's destroy is overridden to not send an http delete request,
        * so no error will ensue on the server if we enter here from the user
        * reading its contents (the note was already destroyed on the server in the case).
        * */
        this.channel.trigger( 'noteView:flashNoteDestruct', this.model );

        /*
        * (Want to go through higher level active note process -- not just the delete)
        * It appears we treat 'open' notes as the active note.
        * TODO: should prob combo this with the above in one workflow?
        * DVBC-1619 -- don't do if called from successful save of note not created for current user ( changeActiveNote already fired ).
        * ( active note is checked in subscriptionCallbacks.notes:setActiveNote and it will be null -- prevent from entering that,
        *  it doesn't make sense here anyway ).
        * */

        if ( !postSaveOfNewNoteSentToOtherUser ) {
            // Active Note Already Changed Here -- set to null -- don't need to go through workflow again
            this.channel.trigger( 'notes:changeActiveNote', null, { flashNoteDestructed: true} );
        }

    },
    _stopFlashingIcon: function() {
        this.ui.flashIcon.stop(true); //(remove from queue)
    },
    // should this be blowup?
    onDestroy: function() {

        this._stopFlashingIcon();
        this.$timer && this.$timer.stop(true).remove();
        NoteView.prototype.destroy.call(this);

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/flash/flashNote.js
 ** module id = 280
 ** module chunks = 0
 **/